import React from 'react';
import AppBarForInactiveUser from './AppBarForInactiveUser';
import { Grid, TextField, Button, InputAdornment } from '@mui/material';
import OTPInput, { ResendOTP } from 'otp-input-react';
import { base_url, getotp, verifyotp } from '../../utils';
import axios from 'axios';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const InvactiveUser = () => {
  const [state, setState] = React.useState({
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal } = state;
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  //nofity above
  document.body.style.backgroundColor = '#fdfaff';
  const [mbNumber, setMbNumber] = React.useState('');
  const [OTP, setOTP] = React.useState('');
  const [showEnterOtp, setShowEnterOtp] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [severity, setSeverity] = React.useState('success');

  const handleClick1 = () => {
    let link = base_url + getotp;
    let body = { mobile_number: mbNumber };
    setLoading(true);
    axios
      .post(link, body)
      .then((res) => {
        console.log(res, 'resinside');
        setShowEnterOtp(true);
      })
      .catch((err) => {
        console.log(err.response.data.message, 'errinside');
        setErrMsg(err.response.data.message);
        setSeverity('error');
        handleClick();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleclick2 = () => {
    let link2 = base_url + verifyotp;
    if (OTP.length !== 4) {
      return '';
    }
    let body2 = { otp: OTP, mobile_number: mbNumber };

    axios
      .post(link2, body2)
      .then((res) => {
        console.log(res.data.message, 'resdata');
        if (res.data.error) {
          setSeverity('error');
        } else {
          setSeverity('success');
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
        setErrMsg(res.data.message);

        handleClick();
      })
      .catch((err) => console.log(err, 'errddd'));
  };

  return loading ? (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </div>
  ) : (
    <div style={{ textAlign: 'left', padding: '15px' }}>
      <AppBarForInactiveUser />

      <div
        style={{
          marginTop: '50px',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          marginBottom: '20px',
        }}
      >
        <div style={{ fontWeight: 600, fontSize: '22px' }}>
          Delete Your Taskmo{' '}
        </div>
        <div style={{ fontWeight: 600, fontSize: '22px' }}>Account</div>
      </div>
      <div style={{ fontWeight: 600, marginBottom: '10px' }}>
        Enter Mobile Number{' '}
      </div>
      <div style={{ color: '#797979', fontSize: '10px', marginBottom: '10px' }}>
        Please provide the number you used for creating Taskmo account
      </div>

      <TextField
        id="outlined-basic"
        variant="outlined"
        fullWidth
        type="number"
        size="small"
        value={mbNumber}
        InputProps={{
          startAdornment: <InputAdornment position="start">+91</InputAdornment>,
        }}
        onChange={(e) => setMbNumber(e.target.value)}
        onInput={(e) => {
          e.target.value = Math.max(0, parseInt(e.target.value))
            .toString()
            .slice(0, 10);
        }}
      />

      {showEnterOtp && (
        <div style={{ marginTop: '20px' }}>
          <div>Please Enter the OTP</div>
          <br />
          <div style={{ display: 'flex', justifyContent: 'left' }}>
            <OTPInput
              value={OTP}
              onChange={setOTP}
              autoFocus
              OTPLength={4}
              otpType="number"
              disabled={false}
              secure={false}
              inputStyles={{
                border: '1px solid #b38cd5 ',
                borderRadius: '8px',
                width: '54px',
                height: '54px',
                fontSize: '12px',
                color: '#000',
                fontWeight: '400',
                caretColor: 'blue',
              }}
            />
          </div>
        </div>
      )}

      <div
        style={{ position: 'fixed', bottom: '0', left: '0', padding: '10px' }}
      >
        <div
          style={{
            background: '#f5f5d7',
            fontSize: '10px',
            border: '.6px solid #b9af40',
            borderRadius: '5px',
            padding: '15px 5px',
            display: 'flex',
            gap: '10px',
          }}
        >
          <div>
            {' '}
            <img src="/hand.svg" alt="" />
          </div>
          <div style={{ color: '#3c3c3c' }}>
            {' '}
            <span style={{ color: 'blue' }}>Attention User:</span> You are about
            to delete your personal information from this application. Just to
            let you know, this action is irreversible. In the future, if you
            would like to reactivate your account using the same information,
            contact our support centre for further assistance.
          </div>
        </div>

        <br />

        <div>
          {' '}
          <Grid container>
            <Grid item xs={12} fullWidth>
              <Button
                disabled={mbNumber.length == 0}
                disableFocusRipple
                onClick={showEnterOtp == false ? handleClick1 : handleclick2}
                disableRipple
                disableElevation
                fullWidth
                variant="contained"
                style={{
                  background: mbNumber.length != 10 ? '#d5d5d5' : '#673295',
                  color: mbNumber.length != 10 ? 'black' : 'white',
                  height: '50px',
                  fontSize: '18px',
                  textTransform: 'none',
                  borderRadius: '10px',
                }}
              >
                {showEnterOtp ? 'Verify OTP' : 'Get OTP'}
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default InvactiveUser;
